import { getResource } from '@dispatch/shared/services';
import { ResourceTaskParams } from '@dispatch/shared/types';
import { useQueries } from 'react-query';

export const useGetMultiResources = (
  resources: { id: string; name: string }[],
  enabled?: boolean,
  params?: Partial<ResourceTaskParams>
) => {
  const queries = resources?.map((resource) => {
    return {
      queryKey: ['multi-resource', resource.id],
      queryFn: () => getResource(resource.id),
    };
  });

  return useQueries(queries ?? []);
};
